import React from "react";

import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import {
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
} from "@mui/material";

import type { ManifestVersionEntry } from "./manifest-preview-constants";

interface ManifestVersionSelectorProps {
  versions: ManifestVersionEntry[];
  selectedVersion: number | null;
  loadingVersion: boolean;
  onVersionChange: (version: number) => void;
  onCompare: () => void;
}

export function ManifestVersionSelector({
  versions,
  selectedVersion,
  loadingVersion,
  onVersionChange,
  onCompare,
}: ManifestVersionSelectorProps): React.ReactElement | null {
  if (versions.length === 0) return null;

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <FormControl size="small" sx={{ minWidth: 160 }}>
        <InputLabel>Version</InputLabel>
        <Select
          value={selectedVersion ?? versions[0]?.version ?? ""}
          label="Version"
          onChange={(e) => onVersionChange(Number(e.target.value))}
          disabled={loadingVersion}
        >
          {versions.map((v) => (
            <MenuItem key={v.version} value={v.version}>
              v{v.version} — {new Date(v.createdAt).toLocaleDateString()}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {loadingVersion && <CircularProgress size={16} />}
      {versions.length >= 2 && (
        <Button
          size="small"
          variant="outlined"
          startIcon={<CompareArrowsIcon />}
          onClick={onCompare}
        >
          Compare Versions
        </Button>
      )}
    </Stack>
  );
}

export default ManifestVersionSelector;
